module.exports = __webpack_public_path__ + "img/credit-bad.748c5473.png";